import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { fallback, zodValidator } from '@tanstack/zod-adapter'
import { SettingsProfile } from '@/components/settings/settings-profile'
import { UsersRolesSection } from '@/components/settings/users-roles-section'

// Phase 24: `?from=connectors-legacy` is set by the splat redirect at
// /connectors/* and consumed by SettingsProfile to fire a one-shot toast.
const settingsSearchSchema = z.object({
  from: fallback(z.enum(['connectors-legacy']).optional(), undefined),
})

export const Route = createFileRoute('/_authenticated/settings')({
  validateSearch: zodValidator(settingsSearchSchema),
  component: SettingsPage,
})

function SettingsPage() {
  return (
    <div className="p-8 max-w-2xl mx-auto">
      <SettingsProfile />
      <div className="mt-6">
        <UsersRolesSection />
      </div>
    </div>
  )
}
